import React, { Component } from "react";
import "./Landing.css"
import Img1 from "../image/image_body.png"
// import Img2 from "../image/Drone_image.png"
import Img3 from "../image/quiz.jpg"
import Img4 from "../image/certfy.jpg"
import Img5 from "../image/chart.png"
import Img6 from "../image/geo_acad.png"
import Img7 from "../image/Geo_logo.webp"
import Img8 from "../image/geostore.png"
import Img9 from "../image/text1.png"
import Img10 from "../image/text.png"
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { GrWorkshop } from "react-icons/gr";
import { PiCertificate } from "react-icons/pi";
import { FaRegChartBar } from "react-icons/fa";
import LandingFooter from "../part/landing.footer";
import FloatingContact from "../part/floating.contact";
import FooterRight from "../part/landing.footer.right";
import ScrollCourse from "../part/course.scroll";
import LandingSearchHeader from "../part/header_search";
import { Link } from "react-router-dom"
import Empty from "../image/empty.svg"
import axios from "axios";
// import NumberDisplay from "../part/currencyValue";
import Video from "../image/vid.mp4"
// import { PiCurrencyNgn } from "react-icons/pi";
// import Logo from "../image/Logo.png"
import FilterCourse from "../part/filter_bar_course";
import ScrollSubCourse from "../part/course.subscroll";
import { FaLongArrowAltRight } from "react-icons/fa";
import Logo from "../image/Logo.png"
import LandingScrollContainer from "../part/landing_scroll_container";
// import OverlayAdvert from "../part/banner_advert";

class Landing_page extends Component {
    state = {
        goals: [
            { id: "1", head: "Sharpen Your Skills", body: "Deepen your practical understanding through one-on-one interaction with expert tutors and hands-on exercises.", icon: <GrWorkshop /> },
            { id: "2", head: "Validate Your Expertise", body: "Earn industry-recognized certificates upon successful completion of our comprehensive courses.", icon: <PiCertificate /> },
            { id: "3", head: "Track Progress ", body: "Monitor your learning journey with our personalized progress tracking system.", icon: <FaRegChartBar /> },
        ],
        topic: [
            { id: "1", head: "Beginners to Intermediate GIS Class", cost: "#140,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "2", head: "Drone Pilot for Beginners", cost: "#300,000", course: "Drone", icon: <PiCertificate /> },
            { id: "3", head: "Beginners to Advanced GIS Class", cost: "#450,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "4", head: "Drone Pilot for Beginners to Professional", cost: "#450,000", course: "Drone", icon: <GrWorkshop /> },
            { id: "5", head: "GIS and Remote Sensing for Agriculture", cost: "#550,000", course: "GIS", icon: <PiCertificate /> },
            { id: "6", head: "Remote Sensing and Google Earth Engine (Level 1)", cost: "#150,000", course: "Remote Sensing", icon: <FaRegChartBar /> },
            { id: "7", head: "Digital Soil Mapping", cost: "#400,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "8", head: "Remote Sensing and Google Earth Engine - (Level 2)", cost: "#200,000", course: "Remote Sensing", icon: <PiCertificate /> },
            { id: "9", head: "GIS and Remote Sensing for Agriculture ", cost: "#550,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "10", head: "AutoCAD For Surveying and Mapping", cost: "#300,000", course: "Survey", icon: <GrWorkshop /> },
            { id: "12", head: "GIS and Remote Sensing for Maritime", cost: "#550,000", course: "GIS", icon: <PiCertificate /> },
            { id: "13", head: "Differential GPS (DGPS) Land Surveying Training ", cost: "#450,000", course: "Survey", icon: <FaRegChartBar /> },
            { id: "14", head: "GIS with Python in ArcGIS Beginners - Intermediate", cost: "#120,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "15", head: "WORKSHOP AND SEMINAR", cost: "Free", course: "All", icon: <PiCertificate /> },
            { id: "16", head: "Online Scripting in ArcGIS - Advanced", cost: "#140,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "17", head: "Spatial Analysis using ArcGIS", cost: "#150,000", course: "GIS", icon: <FaRegChartBar /> },
            { id: "18", head: "Managing Geospatial Data in ArcGIS", cost: "#150,000", course: "GIS", icon: <GrWorkshop /> },
            { id: "19", head: "Image analysis with ArcGIS", cost: "#150,000", course: "GIS", icon: <PiCertificate /> },
            { id: "20", head: "GIS Field data collection and management", cost: "#150,000", course: "GIS", icon: <FaRegChartBar /> },

        ],
        activePage: 0,
        autoSlideEnabled: true,
        activeGoalId: null,
        selectedCourse: "All",
        showFullText: "See more",
        course: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",

        headbutton: "",
        loading: false,

        Reviews: []



    }

    componentDidMount() {
        this.startAutoSlide();
        this.fetchCourses()
        this.fetchReviews()
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);

    }
    startAutoSlide() {
        this.intervalId = setInterval(() => {
            if (this.state.autoSlideEnabled) {
                this.handleNext();
            }
        }, 10000); // Change to 10 seconds
    }

    handleNext() {
        this.setState((prevState) => ({
            activePage: (prevState.activePage + 1) % 2,
        }));

        this.pauseAutoSlide();
    }

    handlePrev() {
        this.setState((prevState) => ({
            activePage: (prevState.activePage - 1 + 2) % 2, // Ensure it loops correctly
        }));

        this.pauseAutoSlide();
    }

    pauseAutoSlide() {
        this.setState({ autoSlideEnabled: false });
        setTimeout(() => {
            this.setState({ autoSlideEnabled: true });
        }, 10000); // Resume auto-slide after 10 seconds
    }


    handleClick = (id) => {
        this.setState({ activeGoalId: id });
        const images = document.querySelectorAll('.landing_images img');
        images.forEach((img, index) => {
            img.classList.remove('active');
            if (index === (id - 1)) {
                img.classList.add('active');
            }
        });
    };


    // handleFilterChange = (course) => {
    //     this.setState({ selectedCourse: course });
    // };

    filterData = () => {
        const { selectedCourse, course } = this.state;
        if (selectedCourse === 'All') {
            return course;
        } else {
            return course.filter((item) => item.labels === selectedCourse);
        }
    };
    toggleText = () => {
        this.setState({ showFullText: !this.state.showFullText });
    };
    fetchCourses = async () => {
        this.setState({ loading: true })
        const accessToken = localStorage.getItem("accessToken");
        let headers = {}; // Initialize an empty headers object

        if (accessToken) {
            headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        }

        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
                headers: headers,
            });
            this.setState({ course: response.data });
            console.log("API Response:", response.data);
            this.setState({ loading: false })
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                this.setState({ loading: true })
                window.location.href = "/";

            } else {
                console.error("Error fetching data:", error);
                this.setState({ loading: true })
            }
        }
    };





    fetchReviews = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            // const course_id = this.props.course_id;
            // const courseId = parseInt(course_id, 10);

            let headers = {};
            if (accessToken) {
                headers = {
                    Authorization: `Bearer ${accessToken}`,
                };
            }

            // Fetch both APIs concurrently
            const [userReviewsRes, tutorReviewsRes] = await Promise.all([
                axios.get(`https://api.geoinfoacademy.com/api/reviews/`, { headers }),
                axios.get(`https://api.geoinfoacademy.com/api/tutor/reviews/`, { headers }),
            ]);

            const userReviews = userReviewsRes.data;
            const tutorReviews = tutorReviewsRes.data;

            // Format tutor reviews to match the format
            const formattedTutorReviews = tutorReviews.map(review => ({
                id: `tutor-${review.id}`,
                rating: review.rating,
                comment: review.comment,
                created_at: new Date().toISOString(), // Use current date if no date provided
                user: {
                    first_name: review.full_name.split(" ")[0],
                    last_name: review.full_name.split(" ")[1] || "",
                    profile_picture: review.pic_or_video || "", // fallback if not available
                },
            }));

            const allReviews = [...userReviews, ...formattedTutorReviews];

            // Sort by date (optional)
            allReviews.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

            this.setState({ Reviews: allReviews });
            console.log("user review, tutor review and general review ", userReviews, tutorReviews, allReviews)

        } catch (error) {
            console.error("Error fetching data for review:", error);
        }

    };







    // this is to handle the group of button
    handleFilterButton = (value) => {
        this.setState({
            headbutton: value
        })
    }

    initialheaderbutton = () => {
        const courses = this.state.course;
        if (this.state.headbutton === "" || this.state.headbutton === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.headbutton);

        }
    };
    // the filter start here 
    initialfilterbytype = () => {
        const courses = this.initialheaderbutton();
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);

        }
    };

    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();

        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        }

        else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);

        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        }
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        }
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };

    filterGeneralPhysical = () => {
        const courses = this.initialfilterbystatus();
        return courses.filter((item) => item.training_type === "General Physical Class");
    }
    filterPrivatePhysical = () => {
        const courses = this.initialfilterbystatus();
        return courses.filter((item) => item.training_type === "Physical Private Class");
    }
    filterOnline = () => {
        const courses = this.initialfilterbystatus();
        return courses.filter((item) => item.training_type === "Online Prerecorded" || item.training_type === "Online Live with Facilitator");
    }


    handleFilterChange = (filterType, filterLevel, filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };

    render() {
        console.log("checking scroll course", this.state.course)

        const goals_list = this.state.goals
        const goal = goals_list.length ?
            goals_list.map(list => {
                return (
                    <section className={`content ${list.id === this.state.activeGoalId ? 'active' : ''}`} key={list.id}>
                        <button onClick={() => this.handleClick(list.id)}>
                            {list.icon}
                            <h5>{list.head}</h5>
                            <p>{list.body}</p>
                        </button>
                    </section>
                )
            }) : (
                <div className="no_course">
                    <div className="image">
                        <img src={Empty} alt="no course" />
                    </div>
                    <br />
                    <p>No Available Course </p>
                </div>

            )
        const { activePage } = this.state;
        this.handleNext = this.handleNext.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        // const { course } = this.state
        // const dropdown_topic = course.length ?
        //     course.map(list => {
        //         return (

        //             <section className="landing_topic width " key={list.id}>
        //                 <Link to={"/Landing_description/" + list.id}>
        //                     <div className="course_video">
        //                         <img src={list.thumbnail} alt={"course" + list.id} />
        //                     </div>
        //                     <div className="course_Writeup">
        //                         <h4>
        //                             <span>{list.labels} - {list.tags}</span>
        //                             <br />
        //                             {list.title}
        //                         </h4>
        //                         <p><PiCurrencyNgn /><NumberDisplay value={list.price} /></p>

        //                     </div>
        //                 </Link>
        //             </section>
        //         )
        //     }) : (
        //         // <div className="no_course">
        //         //     <div className="image">
        //         //         <img src={Empty} alt="no course" />
        //         //     </div>
        //         //     <br />
        //         //     <p>No Available Course </p>
        //         // </div>
        //         <div className="loading_error">
        //             <div className="cover">
        //                 <section className="image">
        //                     <img src={Logo} alt="not avaialable" /><br />
        //                 </section>
        //             </div>
        //         </div>
        //     )

        const filteredData = this.initialfilterbystatus()
        const physicalfilteredData = this.filterGeneralPhysical()
        const privatefilterData = this.filterPrivatePhysical()
        const onlinefilterData = this.filterOnline()
        // this.filterData();



        // const review = [
        //     {
        //       id : 1,  
        //       full_name: "Michael Okafor",
        //       comment: "The drone survey training gave me practical skills I now use daily in my career.",
        //       rate: [
        //         { rating: 5 },
        //         { rating: 4 },
        //         { rating: 5 }
        //       ],
        //       image: [
        //         { picture: "https://example.com/images/michael.jpg" }
        //       ]
        //     },
        //     {
        //         id: 2,                
        //       full_name: "Aisha Bello",
        //       comment: "I loved how detailed the GIS mapping lessons were. The instructors made everything clear and easy to apply.",
        //       rate: [
        //         { rating: 4 },
        //         { rating: 5 },
        //         { rating: 4 }
        //       ],
        //       image: [
        //         { picture: "https://example.com/images/aisha.jpg" }
        //       ]
        //     },
        //     {
        //         id: 3,
        //       full_name: "Emeka Johnson",
        //       comment: "From zero knowledge to handling professional drone surveys — this course was worth every naira.",
        //       rate: [
        //         { rating: 5 },
        //         { rating: 5 },
        //         { rating: 5 }
        //       ],
        //       image: [
        //         { picture: "https://example.com/images/emeka.jpg" }
        //       ]
        //     }
        //   ]

        console.log(this.state.Reviews, "list of review")

        return (
            <div className="body">
                <LandingSearchHeader />
                <div className="landing_cover">

                    <div className={`Page ${activePage === 0 ? 'one' : ''}`}>
                        <div className="landing_img">
                            <img src={Img1} alt="GIS group" />
                        </div>
                        <div className="landing_content">
                            <h2>Unleash Your Inner Geospatial Explorer</h2>
                            <p>Learn how to analyze spatial data, create stunning maps, and unlock valuable insights from the world around you.</p>
                            <Link to="/sign_up" ><button className="first">Sign Up Now </button></Link>
                            <Link to="/login"><button>Login To Account</button></Link>
                        </div>
                    </div>
                    <div className={`Page ${activePage === 1 ? 'one' : 'two'}`}>
                        <div className="Landing_image">
                            {/* <img src={Img2} alt="drone body" /> */}
                            <video autoPlay muted controls={false} loop>
                                <source src={Video} type="video/mp4" />
                            </video>
                            <div className="Landing_content">
                                <h2>Take Flight: From Theory to Practice</h2>
                                <p>Join a vibrant community of fellow learners and connect with industry professionals.</p>
                                <Link to="/landing_course"><button>Find Course</button></Link>
                            </div>

                        </div>
                    </div>
                    <button onClick={this.handlePrev} className="Landing_next"><FaAngleLeft /></button>
                    <button onClick={this.handleNext} className="Landing_next"><FaAngleRight /></button>
                </div>
                <div className="Landing_info">
                    <h3>Unveiling the Data <br /> Our Growing Community of Aviation Drone, GIS and Land Survey Enthusiasts</h3>
                    <div className="landing_numbers">
                        <h4>20<br /><span>courses</span></h4>
                        <h4>2,500<br /><span>students</span></h4>
                        <h4>200<br /><span>Organization</span></h4>
                        <h4>2<br /><span>Location</span></h4>
                    </div>
                </div>
                <div className="landing_video">
                    <h3><span>Trending courses</span><br /> Advance Your Career</h3>
                    <div className="course_contain">
                        <div className="course_list">
                            <section className={`filterbutton ${this.state.headbutton === "GIS" ? "active" : ""}`} onClick={() => this.handleFilterButton("GIS")}><p><span>1</span> GIS</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Drone" ? "active" : ""}`} onClick={() => this.handleFilterButton("Drone")}><p><span>2</span> Drone</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Survey" ? "active" : ""}`} onClick={() => this.handleFilterButton("Survey")}><p><span>3</span> Survey</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Remote Sensing" ? "active" : ""}`} onClick={() => this.handleFilterButton("Remote Sensing")}><p><span>4</span> Remote Sensing</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Webinar" ? "active" : ""}`} onClick={() => this.handleFilterButton("Webinar")}><p><span>5</span> Webinar</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Podcast" ? "active" : ""}`} onClick={() => this.handleFilterButton("Podcast")}><p><span>6</span> Podcast</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                            <section className={`filterbutton ${this.state.headbutton === "Event" ? "active" : ""}`} onClick={() => this.handleFilterButton("Event")}><p><span>7</span> Event</p><p className="blue">Explore <FaLongArrowAltRight /></p></section>
                        </div>
                    </div>
                    <div style={{ width: "100%", height: "auto", backgroundColor: "white", position: "sticky", top: "0px", paddingTop: "10px", zIndex: "3" }}>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>
                    <div style={{ overflow: "hidden", width: "100%" }}>
                        <div className="landing_scroll_background">

                            {/* <nav className="landing_button_cover">
                        <button onClick={() => this.handleFilterChange('All')} className={this.state.selectedCourse === 'All' ? 'active' : ''}>All Courses</button>
                        <button onClick={() => this.handleFilterChange('GIS')} className={this.state.selectedCourse === 'GIS' ? 'active' : ''}>GIS</button>
                        <button onClick={() => this.handleFilterChange('Drone')} className={this.state.selectedCourse === 'Drone' ? 'active' : ''}>Drone</button>

                    </nav> */}
                            <div className="landing-main-scroll-cover">
                                {!this.state.loading ?
                                    <ScrollCourse topics={filteredData} headline={"Explore All Courses"} /> :
                                    <div className="loading_error" style={{ width: "100%" }}>
                                        <div className="cover">
                                            <section className="image">
                                                <img src={Logo} alt="not avaialable" /><br />
                                            </section>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="landing_scroll_background">
                            <div className="landing-main-scroll-cover">
                                {!this.state.loading ?
                                    <ScrollSubCourse topics={physicalfilteredData} headline={"Physical course"} /> :
                                    <div className="loading_error" style={{ width: "100%" }}>
                                        <div className="cover">
                                            <section className="image">
                                                <img src={Logo} alt="not avaialable" /><br />
                                            </section>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="landing_scroll_background">
                            <div className="landing-main-scroll-cover">
                                {!this.state.loading ?
                                    <ScrollSubCourse topics={onlinefilterData} headline={"Online course"} /> :
                                    <div className="loading_error" style={{ width: "100%" }}>
                                        <div className="cover">
                                            <section className="image">
                                                <img src={Logo} alt="not avaialable" /><br />
                                            </section>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="landing_scroll_background">
                            <div className="landing-main-scroll-cover">
                                {!this.state.loading ?
                                    <ScrollSubCourse topics={privatefilterData} headline={"Private course"} /> :
                                    <div className="loading_error" style={{ width: "100%" }}>
                                        <div className="cover">
                                            <section className="image">
                                                <img src={Logo} alt="not avaialable" /><br />
                                            </section>
                                        </div>
                                    </div>}
                            </div>
                        </div>

                    </div>
                    {/* <h3>Training Services</h3>
                    <div className="landing_course">

                        <div className="landing_allcourse" style={{ height: this.state.showFullText ? '300px' : 'auto' }} >
                            {dropdown_topic}
                        </div>
                        <button onClick={this.toggleText}>{this.state.showFullText ? 'See More' : 'Show Less'}</button>
                    </div> */}
                </div>




                <div className="Landing_goals">
                    <h3><span>GIS & Drone</span><br /> Achieve Your Geospatial Goals</h3>
                    <div className="landing_covers">
                        {goal}
                    </div>
                    <div className="landing_images">
                        <img src={Img3} alt="quiz" className="one" />
                        <img src={Img4} alt="certify" className="two" />
                        <img src={Img5} alt="chart" className="three" />
                    </div>
                </div>





                <div className="landing_sponsor">
                    <img src={Img6} alt="academi" />
                    <img src={Img7} alt="geoinfotech" />
                    <img src={Img8} alt="geostore" />
                </div>



                <div className="landing_writeup">
                    <div className="Landing_image">
                        <img src={Img9} alt="role" />
                    </div>
                    <div className="Landing_contents">
                        <h3>Personalized Learning</h3>
                        <p>Benefit from flexible learning schedules, personalized learning paths, and access to a wealth of resources designed to help you succeed.</p>

                    </div>
                    <div className="Landing_image">
                        <img src={Img10} alt="role" />
                    </div>
                    <div className="Landing_contents">
                        <h3>Learn from the Best</h3>
                        <p>Gain valuable insights and guidance from experienced professionals in the GIS and drone fields.</p>
                    </div>
                </div>



{this.state.Reviews.length > 0 &&
                <div className="landing_review">
                    <h3>
                        <span>Testimonials</span><br />
                        Voices Of Our Alumini
                    </h3>


                    {/* <div className="scroller-cover">
                        <div className= "scroller-cover-head">
                            <h4>Google My Business: Trusted Reviews</h4>
                        </div>
                    <LandingScrollContainer gadget={review} />
                    </div> */}

                    
                        <div className="scroller-cover">
                            {/* <div className="scroller-cover-head">
                            <h4>Course Reviews: Course Feedback</h4>
                        </div> */}
                            <LandingScrollContainer gadget={this.state.Reviews} />
                        </div>
                   
                </div> }



                <FloatingContact />
                <LandingFooter />
                <FooterRight />

                {/* <OverlayAdvert /> */}

            </div>
        )
    }
}
export default Landing_page